import { PreferenceState } from '@bingads-webui-campaign-react/popup-components';

export const customUserGovernanceConfig = {
  // If the expiration date is set and it is in the past, do not show the component
  // set the value with the format: new Date('2023/12/31')
  expirationDate: null,
  [PreferenceState.INIT]: {
    // cooldownDays is the number of days after the user can see the component again
    cooldownDays: 0,
    // secondaryButtonText is the text that will be displayed on the secondary button
    secondaryButtonText: _TL_('Remind me later'),
    // stateMachine is the state machine that will be used to transition between states
    stateMachine: {
      // onDone is the state that will be set when the user clicks on the primary button
      onDone: PreferenceState.SUBMIT,
      // onDismiss is the state that will be set when the user clicks on the secondary button
      onDismiss: PreferenceState.FIRST_DISMISS,
      // onClose is the state that will be set when the user clicks on the close button
      onClose: PreferenceState.FIRST_DISMISS,
    },
  },
  [PreferenceState.FIRST_DISMISS]: {
    cooldownDays: 7,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.SUBMIT,
      onDismiss: PreferenceState.SECOND_DISMISS,
      onClose: PreferenceState.SECOND_DISMISS,
    },
  },
  [PreferenceState.SECOND_DISMISS]: {
    cooldownDays: 14,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.SUBMIT,
      onDismiss: PreferenceState.THIRD_DISMISS,
      onClose: PreferenceState.THIRD_DISMISS,
    },
  },
  [PreferenceState.THIRD_DISMISS]: {
    cooldownDays: 30,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.SUBMIT,
      // When dismiss the popup 4 times, treat it as submit to cool down
      onDismiss: PreferenceState.SUBMIT,
      onClose: PreferenceState.SUBMIT,
    },
  },
  [PreferenceState.SUBMIT]: {
    cooldownDays: 30 * 6,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.SUBMIT,
      onDismiss: PreferenceState.FIRST_DISMISS,
      onClose: PreferenceState.FIRST_DISMISS,
    },
  },
};
